import script from "./VariableBadge.vue?vue&type=script&lang=ts&setup=true"
export * from "./VariableBadge.vue?vue&type=script&lang=ts&setup=true"

import "./VariableBadge.vue?vue&type=style&index=0&id=2e068d11&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e068d11"]])

export default __exports__